import { useQuery } from '@tanstack/react-query';
import { getCardStats, getMeetingsByAgenda, getMeetingTimePerMonth, getStatusBreakdownPerPeriod, getVisitsPerMonth } from '../service/dashboard';

export const useCardStats = () => {
    return useQuery({
        queryKey: ['getCardStats'],
        queryFn: getCardStats,
    });
};

export const useVisitsPerMonth = (filters: any) => {
    return useQuery({
        queryKey: ['visits-per-month', filters],
        queryFn: () => getVisitsPerMonth(filters),
    });
};

export const useMeetingTimePerMonth = (filters: any) => {
    return useQuery({
        queryKey: ['visit-hours-per-month', filters],
        queryFn: () => getMeetingTimePerMonth(filters),
    });
};


export const useStatusBreakdownPerPeriod = (filters: any) => {
    return useQuery({
        queryKey: ['getStatusBreakdownPerPeriod', filters],
        queryFn: () => getStatusBreakdownPerPeriod(filters),
    });
};

export const useMeetingsByAgenda = () => {
    return useQuery({
        queryKey: ['getMeetingsByAgenda'],
        queryFn: getMeetingsByAgenda,
    });
};


